import React from 'react';
import PropTypes from 'prop-types';

/* eslint-disable max-len */
const SrTodayDot = ({ cy, cx }) => {
  return (
    <svg x={cx - 11} y={cy - 12} width='33' height='32' viewBox='0 0 33 32' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g filter='url(#filter0_d_12243_42639)'>
        <circle cx='11.6' cy='11.6' r='11.6' transform='matrix(-1 0 0 1 28 0.400009)' fill='white' />
        <circle cx='6' cy='6' r='9' transform='matrix(-1 0 0 1 22.4023 6)' fill='#FFCD00' stroke='white' strokeWidth='6' />
      </g>
      <defs>
        <filter id='filter0_d_12243_42639' x='9.53674e-07' y='0' width='32.4023' height='32' filterUnits='userSpaceOnUse' colorInterpolationFilters='sRGB'>
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feColorMatrix in='SourceAlpha' type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' result='hardAlpha' />
          <feOffset dy='4' />
          <feGaussianBlur stdDeviation='2' />
          <feComposite in2='hardAlpha' operator='out' />
          <feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0' />
          <feBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow_12243_42639' />
          <feBlend mode='normal' in='SourceGraphic' in2='effect1_dropShadow_12243_42639' result='shape' />
        </filter>
      </defs>
    </svg>
  );
};
/* eslint-enable max-len */

SrTodayDot.propTypes = {
  cy: PropTypes.number.isRequired,
  cx: PropTypes.number.isRequired,
};

export default SrTodayDot;
